import React from "react";
import { Star } from "lucide-react";

const TestimonialSection = ({ reviews }) => (
  <section className="px-4 py-7 md:px-8 md:py-10 lg:px-12" data-testid="reviews-section">
    <div className="mb-4 md:mb-6">
      <span className="font-mono text-[10px] uppercase tracking-[0.26em] text-cynos-red md:text-xs">Real Reviews</span>
      <h2 className="mt-2 font-anton text-[clamp(2rem,8vw,3rem)] uppercase leading-none md:text-5xl">From Our Tribe.</h2>
    </div>
    <div className="grid gap-3 md:grid-cols-3 md:gap-5">
      {reviews.map((review) => (
        <article key={review.name} className="rounded-[8px] border border-white/10 bg-cynos-card p-5 md:p-6">
          <div className="flex items-center gap-3">
            <img src={review.img} alt={review.name} className="h-14 w-14 rounded-[8px] object-cover" loading="lazy" decoding="async" />
            <div>
              <div className="font-bold uppercase text-sm">{review.name}</div>
              <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-500">{review.city}</div>
            </div>
          </div>
          <div className="flex gap-0.5 mt-4">
            {[...Array(review.rating)].map((_, i) => <Star key={i} size={14} fill="#FF3333" stroke="#FF3333" />)}
          </div>
          <p className="text-zinc-300 mt-3 text-sm leading-relaxed">"{review.body}"</p>
        </article>
      ))}
    </div>
  </section>
);

export default TestimonialSection;
